import { getUrl, downloadData } from 'aws-amplify/storage';
import { awsConfig } from '@/aws_config';

type StorageGetOptions = {
  level?: string;
  download?: boolean;
};

const getBucket = () => ({
  bucketName: awsConfig.Storage.AWSS3.bucket,
  region: awsConfig.Storage.AWSS3.region
});

const normalizeVisibility = (
  level?: string
): 'public' | 'protected' | 'private' => {
  if (level === 'public' || level === 'guest') {
    return 'public';
  }
  if (level === 'private') {
    return 'private';
  }
  return 'protected';
};

const buildStoragePath = (
  fileKey: string,
  visibility: 'public' | 'protected' | 'private'
): string | (({ identityId }: { identityId?: string }) => string) => {
  if (/^(public|protected|private)\//.test(fileKey)) {
    return fileKey;
  }

  const fileName = fileKey.split('/').pop() || fileKey;

  if (visibility === 'public') {
    return `public/${fileName}`;
  }

  if (visibility === 'protected') {
    return ({ identityId }) => `protected/${identityId}/${fileName}`;
  }

  return ({ identityId }) => `private/${identityId}/${fileName}`;
};

const getStorageFile = async (
  key: string,
  additionalProperties: StorageGetOptions = {
    level: 'protected',
    download: true
  }
): Promise<any> => {
  try {
    const visibility = normalizeVisibility(additionalProperties.level);
    const path = buildStoragePath(key, visibility);
    const bucket = getBucket();

    if (additionalProperties.download) {
      const { body } = await downloadData({
        path,
        options: {
          bucket
        }
      }).result;

      return {
        Body: body as unknown as Blob
      };
    }

    const { url } = await getUrl({
      path,
      options: {
        bucket
      }
    });

    return url.toString();
  } catch (e) {
    console.error(e);
    return null;
  }
};

export { getStorageFile };
